import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get affirmation List
export const getAffirmationlist = createAsyncThunk(
  "getAffirmationlist",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(
        `/affirmation/get-affirmation${queryString}`
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Create Edit affirmation
export const createAffirmation = createAsyncThunk(
  "createAffirmation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(
        `/affirmation/add-affirmation`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const editAffirmation = createAsyncThunk(
  "editAffirmation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(
        `/affirmation/update-affirmation`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete affirmation
export const deleteAffirmation = createAsyncThunk(
  "deleteAffirmation",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(
        `/affirmation/delete-affirmation/${id}`
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const affirmationSlice = createSlice({
  name: "affirmation",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // get affirmation list
      .addCase(getAffirmationlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAffirmationlist.fulfilled, (state, action) => {
        state.loading = false;
        state.getAffirmationlistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getAffirmationlist.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //create affirmation
      .addCase(createAffirmation.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAffirmation.fulfilled, (state, action) => {
        state.loading = false;
        state.createAffirmationStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createAffirmation.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //Edit affirmation
      .addCase(editAffirmation.pending, (state) => {
        state.loading = true;
      })
      .addCase(editAffirmation.fulfilled, (state, action) => {
        state.loading = false;
        state.editAffirmationStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editAffirmation.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Delete affirmation
      .addCase(deleteAffirmation.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAffirmation.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteAffirmationStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteAffirmation.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setAffirmation } = affirmationSlice.actions;
export default affirmationSlice.reducer;
